/** Dark report/popup palette — matches ReportsPage / Sidebar (black, not blue-gray). */
export const REPORT_BG = '#0A0A0A';
export const REPORT_BG_SOFT = '#141414';
export const REPORT_BG_INPUT = '#1a1a1a';
export const REPORT_BORDER = 'rgba(255,255,255,0.12)';

/** Modal shell (ReportDisplayModal, generation popups). */
export const reportModalPanelClass = (darkMode) =>
  darkMode ? 'bg-[#0A0A0A]' : 'bg-white';

export const reportModalSurfaceClass = (darkMode) =>
  darkMode ? 'bg-[#141414] border-white/10' : 'bg-gray-50 border-gray-200';

export const reportModalInputClass = (darkMode) =>
  darkMode
    ? 'bg-[#1a1a1a] border-white/10 text-white placeholder-gray-400'
    : 'bg-white border-gray-300 text-gray-900';

export const reportModalBorderClass = (darkMode) =>
  darkMode ? 'border-white/10' : 'border-gray-200';

export const reportModalHeaderBgClass = (darkMode) =>
  darkMode ? 'bg-[#141414]' : 'bg-gray-100';

/**
 * Parse YYYY-MM-DD as a local calendar date (avoids UTC off-by-one in headers).
 */
export function formatReportPrintedDate(value) {
  if (!value) return '';
  const s = String(value).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) {
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
